import React, { useState,useEffect } from "react";
import { Link } from "react-router-dom";
import Header from "../layouts/Header";
import Sidebar from "../layouts/Sidebar";
import "../_components/antd.css";
import { Table, Tooltip } from "antd";
//import Data from "../../assets/jsons/user";
import {
  onShowSizeChange,
  itemRender,
} from "../_components/paginationfunction";
import api from "../api/api"


import { useAuth } from "../context/AuthContext";
import { useHistory, useParams } from "react-router-dom";
import AddEmployer from "./AddEmployer";
import EmployerLinkListMobile from "./EmployerLinkListMobile";
import { useTranslation } from "react-i18next";
const EmployerLinkList = () => {
  const {user} = useAuth();
  const { id } = useParams();
const { t } = useTranslation();
  const history = useHistory();
  
  useEffect(()=>{
      fetchData()
  },[])

  const [loadingAgencies, setloadingAgencies] = useState(false);
  const [error, setError] = useState(null);

  const [data, setData] = useState([]);
  const [nextPage, setNextPage] = useState(null);
  const [prevPage, setPrevPage] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [count, setCount] = useState(0);  
  
  const fetchData = async (page = 1) => {

    setloadingAgencies(true)
    setError(null)
    
    try {
      let typeurl;
      if(user.type === "agency")typeurl=`/employer-management/${id}/links/?page=${page}`;
      else return

      const response = await api.get(typeurl); // No need to wrap `data` in an object

      
      setData(response.data.results)
      setNextPage(response.data.next)
      setPrevPage(response.data.previous)
      setCount(response.data.count)

    } catch (error) {
      //console.error("Error submitting form:", error);
      
      // Extract response code if available
      const responseCode =  "Unknown";
      
      setError(responseCode)
     
    } finally {
      setloadingAgencies(false);
    }
  }

  const handlePageChange = (page) => {
    if (page < 1 || page > Math.ceil(count / 10)) return;
    setCurrentPage(page);
    fetchData(page);
  };

  useEffect(() => {
    fetchData();
  }, [id])

  const [menu, setMenu] = useState(false);
  const [show, setShow] = useState(false);

  const toggleMobileMenu = () => {
    setMenu(!menu);
  };

  const columns = [
  {
    title: "#",
    render: (text, record, index) => index + 1,
    sorter: false,
  },
  {
    title: "URL",
    dataIndex: "token",
    render: (token) => {
      const url = `https://crm.kflow.cloud/employer-biodata-shared?token=${token}`;
      const handleCopy = () => {
        navigator.clipboard.writeText(url);
        alert(t("Link copied to clipboard!"));
      };
      return (
        <button
          type="button"
          className="btn btn-link p-0"
          style={{ wordBreak: "break-all" }}
          onClick={handleCopy}
          title="Click to copy"
        >
          https://crm.kflow.cloud/employer-bio...
        </button>
      );
    }
  },
  {
    title: t("Biodata Names"),
    dataIndex: "biodata_info",
    render: (info) => (
      <div>
        {info && info.length > 0
          ? info.map((itemInfo, idx) => (
              <Link
                key={idx}
                className={`badge ${itemInfo.is_shortlisted ? 'bg-blue-light' : 'bg-info'} text-dark me-1 mb-1`}
                style={{ fontSize: "1.1em" }}
                to={{ 
                  pathname: `/biodata/${itemInfo.id}`,
                  state: { profile: itemInfo.details }  // Pass the biodata info as state
                 }}
              >
                {itemInfo.name}
              </Link>
            ))
          : <span className="text-muted">-</span>
        }
      </div>
    )
  },
  {
    title: t("Created By"),
    dataIndex: 'created_by',
  },
  {
    title: t("Created Date"),
    dataIndex: "created_at", 
  },
];
  
  const isMobileDevice = () => {
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;
    return /android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/i.test(userAgent);
  };

  const [screenWidth, setScreenWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => {
        setScreenWidth(window.innerWidth);
    };

    // Add event listener for resizing
    window.addEventListener("resize", handleResize);

    // Cleanup event listener on component unmount
    return () => {
        window.removeEventListener("resize", handleResize);
    };
  }, []);

  return (
    <>
      <div className={`main-wrapper ${menu ? "slide-nav" : ""}`}>
        <Header onMenuClick={() => toggleMobileMenu()} />
        <Sidebar />

        <div className="page-wrapper">
        {
                (loadingAgencies || error) ? (
          <div style={{ textAlign: "center", margin: "10em" }}>
            {loadingAgencies && <i className="fa-solid fa-spinner fa-spin" style={{ fontSize: "4em" }} />}
            {error && (
              <div className="alert alert-danger alert-dismissible fade show" role="alert">
                <strong>Error!</strong> {error}
                {/*<button onClick={fetchData} className="btn btn-danger btn-sm ms-3">
                  Try Again
                </button>*/}
              </div>
            )}
          </div>
        ) : (
             <> 
          <div className="content container-fluid">
            {/* Page Header */}
            <div className="page-header">
              <div className="content-page-header ">
                <h5>{t("Link Biodata List")}</h5>
              </div>
            </div>
            {/* /Page Header */}
            
            <div className="row">
              <div className="col-sm-12">
                {isMobileDevice() || screenWidth <= 576 ? (
                  <>
                    <EmployerLinkListMobile handlePageChange={handlePageChange} currentPage={currentPage} nextPage={nextPage} prevPage={prevPage} count={count} data={data} screenWidth={screenWidth}/>
                  </>
                ) : (
                  <div className="card-table">
                    <div className="card-body">
                      <div className="table-responsive table-hover">
                        <Table
                          pagination={{
                            total: count,
                            current: currentPage,
                            showTotal: (total, range) =>
                              `Showing ${range[0]} to ${range[1]} of ${total} entries`,
                            // showSizeChanger: true,
                            onShowSizeChange: onShowSizeChange,
                            itemRender: (page, type, originalElement) => itemRender(t, handlePageChange, currentPage, prevPage, nextPage, page, type, originalElement),
                          }}
                          columns={columns}
                          dataSource={data}
                        />
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>

         
          </div>
          </>
        )
      }
        </div>

      
      {/* add agency */}
      <AddEmployer refreshData={()=>fetchData()} onRefresh={fetchData}/>
      {/* add agency */}

      </div>
    </>
  );
};


export default EmployerLinkList;
